module.exports = __webpack_public_path__ + "static/media/list-banner-mobile.fb93973b.svg";